export default __webpack_public_path__ + "static/media/convocatoria.d9383988.jpg";